(() => {
  "use strict";
  const instances = new WeakMap();
  function initialise(root = document) {
    const scopes = [...root.querySelectorAll(".clarity-finder[data-service-selector]")];
    if (root.matches?.(".clarity-finder[data-service-selector]")) scopes.unshift(root);
    scopes.forEach(scope => {
      if (instances.has(scope)) return;
      const select = scope.querySelector("[data-clarity-family]");
      const buttons = [...scope.querySelectorAll("[data-selector-family]")];
      if (!select || !buttons.length) return;
      let frame = 0;
      const sync = () => {
        frame = 0;
        const selected = buttons.find(button => button.getAttribute("aria-checked") === "true");
        if (!selected) return;
        select.value = selected.dataset.selectorFamily;
        const group = [...scope.querySelectorAll("[data-category-group]")].find(item => item.dataset.categoryGroup === select.value);
        scope.classList.toggle("clarity-finder__category-single", (group?.querySelectorAll("[data-selector-category]").length || 0) === 1);
      };
      const change = () => buttons.find(button => button.dataset.selectorFamily === select.value)?.click();
      const click = event => {
        if (event.target instanceof Element && event.target.closest("[data-selector-family]")) {
          if (frame) cancelAnimationFrame(frame);
          frame = requestAnimationFrame(sync);
        }
      };
      select.addEventListener("change", change);
      scope.addEventListener("click", click);
      scope.dataset.clarityReady = "true";
      sync();
      instances.set(scope, () => {
        if (frame) cancelAnimationFrame(frame);
        select.removeEventListener("change", change);
        scope.removeEventListener("click", click);
        delete scope.dataset.clarityReady;
        instances.delete(scope);
      });
    });
  }
  function destroy(root) {
    if (root.matches?.(".clarity-finder[data-service-selector]")) instances.get(root)?.();
    root.querySelectorAll?.(".clarity-finder[data-service-selector]").forEach(scope => instances.get(scope)?.());
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => initialise(), { once: true });
  else initialise();
  document.addEventListener("shopify:section:load", event => initialise(event.target));
  document.addEventListener("shopify:section:unload", event => destroy(event.target));
})();
